export default {"src":"/_next/static/media/favorites.0678b40d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};